import { useEffect, useRef } from 'react';

const DEFAULT_MIN_FONT_SIZE = 4;

export function useWidgetAdaptiveText({
  minFontSize = DEFAULT_MIN_FONT_SIZE,
  padding = 0,
}: {
  minFontSize?: number;
  padding?: number;
}) {
  const textRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const el = textRef.current;
    const parent = el?.parentElement;
    if (!el || !parent) {
      return;
    }

    const fit = () => {
      el.style.fontSize = '';
      let fontSize = parseFloat(getComputedStyle(el).fontSize);
      const availableWidth = parent.clientWidth - padding * 2;

      while (el.scrollWidth > availableWidth && fontSize > minFontSize) {
        fontSize -= 0.5;
        el.style.fontSize = `${fontSize}px`;
      }
    };

    fit();

    const observer = new ResizeObserver(fit);
    observer.observe(parent);
    return () => observer.disconnect();
  }, [minFontSize, padding]);

  return { textRef };
}
